import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteListenerService {

	private renderer: Renderer2;

  constructor(private router: Router, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
	  this.listenToRouteChanges();
  }
  // listen current route and check - Salesforce chat enable or not
  private listenToRouteChanges(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
		const button = document.getElementById('embeddedMessagingFrame');
			if (button) {
				console.log('Has botton:', event.urlAfterRedirects);
				if(event.urlAfterRedirects == '/support') {
					this.renderer.setStyle(button, 'display', 'block');
				}
				else {
					this.renderer.setStyle(button, 'display', 'none');
				}
    		}
      });
  }
}
